<template>
    <div class="animate__animated animate__fadeInUp">
        <v-card-title><span v-html="$th('support.upcoming-features.title')"></span></v-card-title>

        <v-card-text>
            <div v-if="get_text('support.upcoming-features.text') !== ''" v-html="get_text('support.upcoming-features.text')" class="mb-5"></div>
            <span v-for="(feature, index) in get_list('support.upcoming-features.features')" :key="index">{{index + 1}}. <span v-html="feature"></span><br></span>
        </v-card-text>
    </div>
</template>

<script>
    export default {
        methods: {
            // Returns the text behind a translation key, an empty string when the key does not exist or has no text
            get_text(key) {
                const text = this.$t(key);
                return typeof text === "string" && text !== key ? text : "";
            },
            // Returns the list behind a translation key, an empty list when the key does not exist
            get_list(key) {
                const list = this.$t(key);
                return Array.isArray(list) ? list : [];
            },
        },
        metaInfo() {
            return {
                title: `${this.$t('meta.page-title-unformated')} - ${this.$t('meta.page-title-upcoming-features')}`,
                meta : [{
                    name   : "description",
                    content: this.$t("meta.description"),
                }]
            }
        },
    }
</script>